<div class="pickup-schedule-container">
  <p class="pickup-schedule-description" *ngIf="!isOutOfHours">
    {{ 'PICKUP_SCHEDULE.DESCRIPTION' | translate }}
  </p>
  <p class="pickup-schedule-description" *ngIf="isOutOfHours">
    {{ 'PICKUP_SCHEDULE.OUT_OF_HOURS_DESCRIPTION_PREFIX' | translate }}<span
      class="pickup-schedule-description__emphasis"
      >{{ 'PICKUP_SCHEDULE.OUT_OF_HOURS_OVERNIGHT_LABEL' | translate }}</span
    >{{ 'PICKUP_SCHEDULE.OUT_OF_HOURS_DESCRIPTION_SUFFIX' | translate }}
  </p>
  <p
    class="pickup-schedule-description font-semibold"
    *ngIf="collectionDateLabel && timeSlots?.length"
  >
    {{ collectionDateLabel }}
  </p>
  <p class="pickup-schedule-description" *ngIf="!timeSlots?.length" role="status">
    {{ 'PICKUP_SCHEDULE.NO_SLOTS' | translate }}
  </p>
  <div class="pickup-schedule-slots">
    <button
      *ngFor="let slot of timeSlots"
      type="button"
      class="pickup-schedule-slot"
      [class.pickup-schedule-slot--selected]="isSelected(slot.id)"
      (click)="onTimeSlotClick(slot)"
    >
      <mat-icon class="pickup-schedule-slot-icon" svgIcon="access_time"></mat-icon>
      <span class="pickup-schedule-slot-text">
        {{ slot.timeFrom }}hs {{ 'PICKUP_SCHEDULE.TIME_RANGE_SEPARATOR' | translate }} {{ slot.timeto }}hs
      </span>
    </button>
  </div>
</div>
